export default __webpack_public_path__ + "static/media/help.44d2d564.webp";